<template>
    <relatorio-page :recibo="true" titulo="Imprimir Boleto" :exportarExcel="false" :paisagem="false" :trazEmpresa="trazEmpresa">
        <div v-html="html"/>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import MasterPage from '../../../components/shared/MasterPage.vue';
import RecebivelService from '../../../core/services/financeiro/RecebivelService'

export default {
  components: { MasterPage },
    data(){
        return {
            service: new RecebivelService(),
            overlay: false,
            ids: null,
            empresaId: null,
            html: "",
            trazEmpresa: true
        }
    },
    created(){
        this.ids = this.$route.query.ids;
        this.empresaId = this.$route.query.empresaId;
        if(this.empresaId != null){
            this.trazEmpresa = false;
        }
    },
    mounted(){        
        this.Carregar();
    },
    methods: {
        Carregar(){

            this.overlay = true;

            if(this.empresaId == null){
                this.service.BoletoHtml(this.ids).then(
                res => {
                    this.html = res.data;
                },
                err =>{
                    this.$swal('Aviso', err.response.data, 'error');
                }
                ).finally(() => {
                    this.overlay = false;
                })
            }
            else{
                this.service.BoletoHtmlDoador(this.ids, this.empresaId).then(
                    res=> {
                        this.html = res.data;
                    },
                    err =>{
                        this.$swal('Aviso', err.response.data, 'error');
                    }
                ).finally(() => {
                    this.overlay = false;
                })
            }

            
        }
    }
}

</script>

<style>

</style>